import { render } from "./startup-users-component.vue?vue&type=template&id=2add91f6&scoped=true&ts=true"
import script from "./startup-users-component.vue?vue&type=script&lang=ts"
export * from "./startup-users-component.vue?vue&type=script&lang=ts"

import "./startup-users-component.vue?vue&type=style&index=0&id=2add91f6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2add91f6"]])

export default __exports__